import React, { useState } from "react";
import {
  Button,
  FormFieldSet,
  InfoTimeCard,
  Modal,
  NewTable,
  PageHeader,
  PageTitle,
  Tag,
  useFormHandler,
} from "../../../components";
import { useNavigate } from "react-router-dom";
import { dateFormator, mapTableRows } from "../../../utils";
import {
  ClientPaymentAccountTypeOpetions,
  ClientPaymentmethodOpetions,
  ClientPaymentOpetions,
  discountOptions,
} from "../../../assets/data/projectData";
import InvoiceDiscountModal from "./payment/InvoiceDiscountModal";
import PaymentDiscountModal from "./payment/PaymentDiscountModal";
import InvoiceDetails from "./PaymentInvoiceDetails";
import AvalableCreditsModal from "./payment/AvalableCreditsModal";
const CreatePayments = () => {
  const navigate = useNavigate();
  const handleBack = () => {
    navigate("/payments");
  };
  const { formData, errors, handleChange } = useFormHandler(
    {
      selectClient: "",
      paymentReceivedDate: "",
      amountReceived: "",
      paymentMethod: "",
      accountType: "",
      referenceNo: "",
      comments: "",
      attachment: [],
    },
    {
      referenceNo: {
        type: "text",
        required: true,
        numwdec: true,
      },
      attachment: { type: "file" }
    }
  );
  const [tableData, setTableData] = useState([
    {
      id: "1",
      invoiceNumber: "16444",
      activity: "03/01/2025-03/31/2025",
      subcustomer: "--",
      invoiceDate: "2025-04-04T00:00:00.000Z",
      dueDate: "2025-05-19T00:00:00.000Z",
      invoiceAmount: "12768.00",
      paymentReceived: "12768.00 USD",
      balance: "12768.00 USD",
      enterPaymentAmount: "12768",
      paymentDiscount: "0.00 USD",
    },
    {
      id: "2",
      invoiceNumber: "16436",
      activity: "03/01/2025-03/31/2025",
      subcustomer: "--",
      invoiceDate: "2025-04-04T00:00:00.000Z",
      dueDate: "2025-05-19T00:00:00.000Z",
      invoiceAmount: "12768.00",
      paymentReceived: "12768.00 USD",
      balance: "12768.00 USD",
      enterPaymentAmount: "12768",
      paymentDiscount: "0.00 USD",
    },
    {
      id: "3",
      invoiceNumber: "16435",
      activity: "03/01/2025-03/31/2025",
      subcustomer: "--",
      invoiceDate: "2025-04-04T00:00:00.000Z",
      dueDate: "2025-05-19T00:00:00.000Z",
      invoiceAmount: "12768.00",
      paymentReceived: "0.00 USD",
      balance: "12768.00 USD",
      enterPaymentAmount: "12768",
      paymentDiscount: "0.00 USD",
    },
  ]);
  const [showInvoiceDetails, setShowInvoiceDetails] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [isInvoiceDiscountModalOpen, setIsInvoiceDiscountModalOpen] =
    useState(false);
  const [isPaymentDiscountModalOpen, setIsPaymentDiscountModalOpen] =
    useState(false);
  const [isAvalableCreditsModalOpen, setIsAvalableCreditsModalOpen] =
    useState(false);
  const [currentRowData, setCurrentRowData] = useState(null);
  const [isAlertModalOpen, setIsAlertModalOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [paymentAmounts, setPaymentAmounts] = useState({});

  const handleChangeTable = (field, row, value) => {
    setTableData((prev) =>
      prev.map((item) =>
        item.id === row.id ? { ...item, [field]: value } : item
      )
    );
  };
  const handleDiscountSelect = (value, row) => {
    setCurrentRowData(row);

    if (value === "Invoice Discount") {
      setIsInvoiceDiscountModalOpen(true);
    } else if (value === "Payment Discount") {
      const enteredAmountStr = paymentAmounts[row.id] || "0";
      const paymentReceived = parseFloat(
        row.paymentReceived.replace(/,/g, "").split(" ")[0]
      );

      const invoiceAmount = parseFloat(row.invoiceAmount.replace(/,/g, ""));
      if (paymentReceived === invoiceAmount) {
        console.log("consoleo triggger");
        setAlertMessage(
          "Cannot apply Discounts to this payment as received amount is equal to open balance."
        );
        setIsAlertModalOpen(true);
      } else {
        setIsPaymentDiscountModalOpen(true);
      }
    }
  };

  const columns = [
    {
      key: "invoiceNumber",
      label: "Invoice Number",
      render: (row) => (
        <div className="flex items-center gap-1 cursor-pointer">
          <span
            className="text-linkblue cursor-pointer"
            onClick={() => {
              setSelectedInvoice(row);
              setShowInvoiceDetails(true);
            }}
          >
            {row.invoiceNumber}
          </span>
        </div>
      ),
    },
    {
      key: "activity",
      label: "Statement Memo Period",
    },
    {
      key: "subcustomer",
      label: "Subcustomer",
    },
    {
      key: "invoiceDate",
      label: "Invoice Date",
      render: (row) => dateFormator(row.invoiceDate, "month-day-year"),
    },
    {
      key: "dueDate",
      label: "Due Date",
      render: (row) => dateFormator(row.dueDate, "month-day-year"),
    },
    {
      key: "invoiceAmount",
      label: "Invoice Amount",
    },
    {
      key: "paymentReceived",
      label: "Payment Received",
    },
    {
      key: "balance",
      label: "Balance",
    },
    {
      key: "enterPaymentAmount",
      label: "Enter Payment Amount",
      render: (row) => (
        <div>
          <FormFieldSet
            type="text"
            placeholder=""
            title=""
            size={"xs"}
            value={row?.enterPaymentAmount}
            onChange={(e) => handleChangeTable("enterPaymentAmount", row, e)}
          />
        </div>
      ),
    },
    {
      key: "paymentDiscount",
      label: "Payment Discount",
    },
    {
      key: "actions",
      label: "Actions",
      render: (row) => (
        <div className="flex items-center gap-2 flex-row">
          <FormFieldSet
            type="select"
            title={""}
            placeholder="Discounts"
            size="xs"
            options={discountOptions}
            onChange={(value) => handleDiscountSelect(value, row)}
          />
        </div>
      ),
    },
  ];

  const mappedRows = mapTableRows(tableData, columns);

  return (
    <div className="w-full">
      {showInvoiceDetails ? (
        <InvoiceDetails
          onBack={() => setShowInvoiceDetails(false)} // Go back to payment form
          invoiceData={selectedInvoice} // Pass selected invoice data
          setReceivePayment={() => {
            /* Your logic */
          }}
          setEditInvoice={() => {
            /* Your logic */
          }}
        />
      ) : (
        <>
          <div>
            <PageHeader
              Section={
                <div className="flex gap-3">
                  <PageTitle
                    title={"CREATE CLIENT PAYMENT"}
                    tag="p"
                    size={"sm"}
                  />
                  <Tag
                    title="Tektree"
                    variant="outlined"
                    className=" !text-neutrals !py-1.5"
                  />
                </div>
              }
              RightSection={
                <div className="flex gap-3">
                  <Button
                    size="sm"
                    title={"Back"}
                    icon={"arrow_left_alt"}
                    onClick={handleBack}
                  />
                  <Button
                    size="sm"
                    title={"Available Credits"}
                    onClick={() => setIsAvalableCreditsModalOpen(true)}
                  />
                </div>
              }
            />
          </div>
          <div>
            <PageHeader
              RightSection={
                <div className="flex gap-3 mt-3">
                  <InfoTimeCard
                    title="Amout Used"
                    color="info"
                    value={"12776.72"}
                    suffix={"USD"}
                    type2
                  />
                  <InfoTimeCard
                    title="Credit Available"
                    color="success"
                    value={"0.00"}
                    suffix={"USD"}
                    type2
                  />
                  <InfoTimeCard
                    title="Amout Used"
                    color="info"
                    value={"0.00"}
                    suffix={"USD"}
                    type2
                  />
                  <InfoTimeCard
                    title="Total Amout in Payment"
                    color="primary"
                    value={"12776.72"}
                    suffix={"USD"}
                    type2
                  />
                </div>
              }
            />
          </div>
          <div className="grid grid-cols-2 xl:grid-cols-3 max-w-7xl gap-x-6 gap-y-8 mt-3">
            <FormFieldSet
              type="select"
              title={"Select Client"}
              placeholder="Select value"
              value={formData.selectClient}
              onChange={(value) => handleChange("selectClient", value)}
              error={errors.selectClient}
              options={ClientPaymentOpetions}
            />
            <FormFieldSet
              type="datepicker"
              title={"Payment Received Date"}
              placeholder="04/05/2025"
              value={formData.paymentReceivedDate}
              onChange={(value) => handleChange("paymentReceivedDate", value)}
              error={errors.paymentReceivedDate}
              showDropdown={false}
            />
            <FormFieldSet
              type="text"
              title={"Amount Received"}
              placeholder="12768.00"
              value={formData.amountReceived}
              onChange={(value) => handleChange("amountReceived", value)}
              error={errors.amountReceived}
            />
            <FormFieldSet
              type="select"
              title={"Payment Method"}
              placeholder="select Payment Method"
              value={formData.paymentMethod}
              onChange={(value) => handleChange("paymentMethod", value)}
              error={errors.paymentMethod}
              options={ClientPaymentmethodOpetions}
            />
            <FormFieldSet
              type="select"
              title={"Account Type"}
              placeholder="select Account Type"
              value={formData.accountType}
              onChange={(value) => handleChange("accountType", value)}
              error={errors.accountType}
              options={ClientPaymentAccountTypeOpetions}
            />
            <FormFieldSet
              type="text"
              title={"Reference No"}
              placeholder="Enter Reference No"
              value={formData.referenceNo}
              onChange={(value) => handleChange("referenceNo", value)}
              error={errors.referenceNo}
            />
            <FormFieldSet
              type="textArea"
              title={"Comments"}
              placeholder="Enter Comments"
              value={formData.comments}
              onChange={(value) => handleChange("comments", value)}
              error={errors.comments}
            />
            <FormFieldSet
              type="file"
              title={"Attachment"}
              placeholder="Choose File"
              value={formData.attachment}
              onChange={(value) => handleChange("attachment", value)}
              error={errors.attachment}
            />
          </div>
          {formData.selectClient && (
            <div>
              <NewTable
                showCheckbox
                rows={mappedRows}
                columns={columns}
                toolbarRight={[
                  { filterButton: false },
                  { DropdownMenu: false },
                ]}
              />
            </div>
          )}
        </>
      )}
      <div>
        <AvalableCreditsModal
          open={isAvalableCreditsModalOpen}
          onClose={() => setIsAvalableCreditsModalOpen(false)}
        />
        <PaymentDiscountModal
          open={isPaymentDiscountModalOpen}
          onClose={() => setIsPaymentDiscountModalOpen(false)}
          rowData={currentRowData}
        />

        <InvoiceDiscountModal
          open={isInvoiceDiscountModalOpen}
          onClose={() => setIsInvoiceDiscountModalOpen(false)}
          rowData={currentRowData}
        />

        <Modal
          isOpen={isAlertModalOpen}
          onClose={() => setIsAlertModalOpen(false)}
          title="ALERT"
          width="max-w-2xl"
        >
          <div className="flex flex-col">
            {alertMessage}
            <div className="mt-8 flex justify-center items-end">
              <Button
                title={"Close"}
                onClick={() => setIsAlertModalOpen(false)}
              />
            </div>
          </div>
        </Modal>
      </div>
    </div>
  );
};

export default CreatePayments;
